<template>
    <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;padding:20px;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/JK/tasks' }">{{ $route.meta.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ taks_name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="调研设置" name="first">
            <div style="width:100%;height:40px;margin-bottom:10px;">
                <div class="top_buttons" style="float:left;">
                    <el-button icon="el-icon-download" @click="Download_template_survey">下载模板</el-button>
                    <el-button icon="el-icon-document" type="primary" @click="Import_question_survey">导入调研</el-button>
                    <span style="margin-left:50px;color:#909399;">
                        <i class="el-icon-info"></i>
                        <span style="font-size:14px;margin-left:4px;">用于组织健康度调研问卷的导入。</span>
                    </span>
                    <el-dialog title="上传文件" :visible.sync="dialogFormVisible_survey" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                        <!-- 这里给子组件传递了getManaQues方法，供子组件调用 -->
                        <upload ref="upload_file" :getHealthSurvey="getManaQues" :task_id="task_id"></upload>
                        <div style="margin-top:-10px;">
                            <el-button @click="dialogCancel_survey">取 消</el-button>
                            <el-button type="primary" @click="uploadFile_survey">立即上传</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <survey-mana ref="survey_mana" :question_info="question_info" :proof_info="proof_info"></survey-mana>
        </el-tab-pane>
        <el-tab-pane label="痛点设置" name="second">
            <div style="width:100%;height:40px;margin-bottom:10px;">
                <div class="top_buttons" style="float:left;">
                    <el-button icon="el-icon-download" @click="Download_template">下载模板</el-button>
                    <el-button icon="el-icon-document" type="primary" @click="Import_question">导入痛点</el-button>
                    <span style="margin-left:50px;color:#909399;">
                        <i class="el-icon-info"></i>
                        <span style="font-size:14px;margin-left:4px;">用于管理痛点调研问卷及其痛点原因分析信息的导入。</span>
                    </span>
                    <el-dialog title="上传文件" :visible.sync="dialogFormVisible" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                        <!-- 这里给子组件传递了getManaQues方法，供子组件调用 -->
                        <upload ref="upload_file" :getPainSpotSurvey="getPainSpotSurvey" :task_id="task_id"></upload>
                        <div style="margin-top:-10px;">
                            <el-button @click="dialogCancel">取 消</el-button>
                            <el-button type="primary" @click="uploadFile">立即上传</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <ques-mana ref="ques_mana" :painspot_info="painspot_info" :proof_info="proof_info"></ques-mana>
        </el-tab-pane>
        <el-tab-pane label="名单设置" name="third">
            <user-mana :task_id="task_id" ref="user_mana"></user-mana>
        </el-tab-pane>
        <el-tab-pane label="条件设置" name="fourth"><cond-mana :task_id="task_id" :sys_params="sys_params"></cond-mana></el-tab-pane>
        <el-tab-pane label="进度跟踪" name="fifth"><pro-gress v-if="isUpdateProgress" :task_id="task_id"></pro-gress></el-tab-pane>
        <el-tab-pane label="结果导出" name="sixth"><ass-results :task_id="task_id"></ass-results></el-tab-pane>
        <!-- <el-tab-pane label="数据中心" name="seventh"><data-center :task_id="task_id"></data-center></el-tab-pane> -->
    </el-tabs>
    </div>
</template>

<script>
import quesMana from "./JianKang_quesmana.vue";
import userMana from "./JianKang_usermana.vue";
import condMana from "./JianKang_condmana.vue";
import proGress from "../ProgressTracking/JianKang_progress.vue";
import assResults from "../AssessResults/JianKang_MyTakePartIn.vue";
import surveyMana from "./JianKang_survey.vue";
// import dataCenter from "./JianKang_DataCenter.vue";

import upload from "../UpLoad.vue";
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
// import relationmana from "./ChengShu_relationmana.vue";
export default { 
    beforeCreate() {
        getdata.getList("checklogin")
              .then((resp) => {
                if(resp.data.usertype != 'admin'){
                    this.$router.push({
                        name: 'notFound',
                    });
                }
              })
              .catch(() => {
                // if(localStorage.getItem("token") != null){
                //     this.$message({
                //         message: '会话超时，请重新登录！',
                //         type: 'warning',
                //     })
                // }
                this.$router.push({
                    path: '/JKlogin',
                });
              })       
        // this.task_id = this.$route.query.taskid;
        // this.getManaQues();
        // this.getManaSurvey();
        // this.getTaskName();
    },
    created() {
        this.task_id = this.$route.query.taskid;
        this.getManaQues();
        this.getPainSpotSurvey();
        // this.getManaSurvey();
        this.getTaskName();
    },
    data() {
        return {
            activeName: 'first',
            dialogFormVisible: false,
            dialogFormVisible_survey: false,
            question_info: [],
            painspot_info: [],
            taks_name: '',
            mana_survey: false,
            task_id: null,
            results_file: {
                file_name: 'mana_survey_results.xlsx',
            },
            isUpdateProgress: false,
            load_user: true,    // 是否加载用户
            sys_params: {}
        }
    },
    components: {
        quesMana,
        userMana,
        condMana,
        proGress,
        assResults,
        upload,
        surveyMana,
        // dataCenter,
    },
    methods: {
        handleClick(tab) {
            if(tab.label=='进度跟踪'){
                // 这里通过给“进度跟踪”子组件设置v-if来让el-tab选择该子组件时重新渲染，从而调用子组件的getProgressInfo()方法
                this.isUpdateProgress = true;   
            }else{
                this.isUpdateProgress = false;
                // 增加对获取名单的处理，仅当选择“名单设置”页签时，才执行获取名单，以防名单过多导致显示慢
                if(tab.label=='名单设置'){
                    if(this.load_user == true){
                        this.$refs.user_mana.getUserInfo();
                        this.load_user = false;
                    }                   
                }
            }
            // console.log(tab, event);
        },
        Download_template() {
            this.$refs.ques_mana.Download_template();
        },
        Download_template_survey() {
            this.$refs.survey_mana.Download_template();
        },
        Import_question() {
            this.dialogFormVisible = true;
            // this.getManaQues();
        },
        Import_question_survey() {
            this.dialogFormVisible_survey = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_survey() {
            this.dialogFormVisible_survey = false;
        },
        uploadFile() {
            // 调用子组件的上传方法
            this.$refs.upload_file.uploadFile('importJKPainSpotSurvey');
            this.dialogFormVisible = false;
            // 这里不能直接使用getManaQues()方法加载已导入的问卷，得在子组件中调用父组件的该方法完成加载
            // this.getManaQues();
        },
        uploadFile_survey() {
            this.$refs.upload_file.uploadFile('importHealthSurvey');
            this.dialogFormVisible_survey = false;
        },
        // 获取组织健康度调研
        getManaQues() {
            let params = {
                task_id: this.task_id,
            }
            getdata.getListP("getHealthSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },      
        getPainSpotSurvey() {
            let params = {
                task_id: this.task_id,
            }
            getdata.getListP("getPainSpotSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_info = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getTaskName() {
            let params;
            params = {
                task_id: this.$route.query.taskid,
                type: 'JK',
            }
            getdata.getListP("getTaskName", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.taks_name = resp.data.task_name;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        export_survey_results() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportSurveyResults", JSON.stringify(this.results_file), params)
            .then(resp => {               
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
::v-deep .el-tabs__item {
    font-size: 20px;
}
::v-deep .el-tabs__content {
    margin-top: 30px;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 30px;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>